import { createRouter, createWebHistory, RouterView } from 'vue-router';
import { routeMiddleware } from '@/i18n';
import Home from '@/pages/Home.vue';
import IssuesDetails from '@/pages/Issues/IssueDetails.vue';
import IssueSubmit from '@/pages/Issues/IssueSubmit.vue';
import Register from '@/features/Register/Register.vue';
import Success from '@/features/Register/Success.vue';
import { ProfilePage } from '@/features/Profile';
import ProfileConfirmPhone from '@/features/Profile/container/ProfileConfirmPhone.vue';
import CompleteProfile from '@/features/Profile/container/CompleteProfile.vue';
import IssueSubmitSuccess from '@/pages/Issues/IssueSubmitSuccess.vue';
import ProfileEdit from '@/features/Profile/container/ProfileEdit.vue';

export const routeNames = {
    home: 'home',
    notFound: 'not-found',
    register: 'register',
    registerSuccess: 'register-success',
    profile: 'profile',
    profileEdit: 'profile-edit',
    issueDetails: 'issue-details',
    issueSubmit: 'issue-submit',
    issueSubmitSuccess: 'issue-submit-success',
    profileConfirmPhone: 'profile-confirm-phone',
    completeProfile: 'complete-profile'
};

export const isAnonymousRoute = (routeName: string): boolean => {
    return router.getRoutes().find(route => route.name === routeName)?.meta?.allowAnonymous === true;
};

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/:locale?',
            component: RouterView,
            children: [
                {
                    name: routeNames.home,
                    path: '',
                    component: Home
                },
                {
                    name: routeNames.register,
                    path: 'register',
                    component: Register,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    name: routeNames.registerSuccess,
                    path: 'register-success',
                    component: Success
                },
                {
                    name: routeNames.profile,
                    path: 'profile',
                    component: ProfilePage
                },
                {
                    name: routeNames.profileEdit,
                    path: 'profile-edit',
                    component: ProfileEdit
                },
                {
                    name: routeNames.profileConfirmPhone,
                    path: 'profile/confirm-phone',
                    component: ProfileConfirmPhone
                },
                {
                    name: routeNames.issueDetails,
                    path: 'issues/details/:id',
                    component: IssuesDetails
                },
                {
                    name: routeNames.issueSubmit,
                    path: 'issues/submit',
                    component: IssueSubmit,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    name: routeNames.completeProfile,
                    path: 'complete-profile',
                    component: CompleteProfile
                },
                {
                    name: routeNames.issueSubmitSuccess,
                    path: 'issues/submit/success/:id',
                    component: IssueSubmitSuccess,
                    meta: {
                        allowAnonymous: true
                    }
                }
            ]
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: { name: routeNames.home }
        }
    ]
});

router.beforeEach(routeMiddleware);

export default router;
